import { jsx as r } from "@emotion/react/jsx-runtime";
import { useTheme as c } from "@emotion/react";
import { HEX_COLORS as p } from "@partoohub/branding";
import { StyledProgressContainer as d, StyledProgress as g, StyledFilled as f } from "./Progress.styled.js";
const h = ({
  progress: o = !1,
  value: e = 0,
  className: a,
  filledClassName: s,
  label: i,
  backgroundColor: l = p.grey,
  filledBackgroundColor: t
}) => {
  const m = c(), n = t ?? m.colors.primary.initial;
  return /* @__PURE__ */ r(d, { role: "progressbar", "aria-valuenow": e, "aria-valuemin": 0, "aria-valuemax": 100, "aria-label": i, className: a, backgroundColor: l, children: o ? /* @__PURE__ */ r(g, {}) : /* @__PURE__ */ r(f, { className: s, background: n, value: e }) });
};
export {
  h as Progress
};
